import {
  AngularComponentsModule,
  GoabDrawer,
  GoabText,
} from '@abgov/angular-components';
import { DrawerCustomPositionDirective } from '@ala/common-ui';
import { CommonModule, Location } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FacilityCapacityEntryStateService } from '../../../../services-v2/states/facility-capacity-entry.state.service';
import { BadgeTransformPipe } from '../../../../shared/pipes/badge-transform.pipe';
import { EnumReverseMappingPipe } from '../../../../shared/pipes/enum-reverse-mapping.pipe';
@Component({
  selector: 'app-capacity-reporting-modal',
  imports: [
    CommonModule,
    AngularComponentsModule,
    GoabDrawer,
    GoabText,
    RouterOutlet,
    EnumReverseMappingPipe,
    BadgeTransformPipe,
    DrawerCustomPositionDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './capacity-reporting-modal.html',
  styleUrl: './capacity-reporting-modal.scss',
})
export class CapacityReportingModal {
  drawerRef = viewChild.required('drawer', { read: ElementRef });
  private readonly _location = inject(Location);
  private readonly _facilityCapacityEntryStateService = inject(
    FacilityCapacityEntryStateService
  );

  isDrawerOpen = this._facilityCapacityEntryStateService.isDrawerOpen;
  selectedFacilityName =
    this._facilityCapacityEntryStateService.selectedFacilityName;
  selectedFacilityStatus =
    this._facilityCapacityEntryStateService.selectedFacilityStatus;

  onDrawerClose() {
    this._facilityCapacityEntryStateService.setDrawerOpenClose = false;
    this._location.back();
  }
}
